<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="8"
          class="my-1"
      />

      <b-col
          md="6"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Name, Telefon etc."
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <div
            v-for="item in items"
            style="padding: .95em; margin-bottom: 0.7em; border-radius: 0.3em; background-color: #252a3e;"
            v-show="!isMobile"
        >
          <b-row>
            <b-col cols="2">
              <b-row style="font-weight: bold; margin-left: 0.25em; font-size: .95em">{{ item.TravelWeekDay }}</b-row>
              <b-row style="font-weight: bold; margin-left: 0.2em; font-size: 1.25em">{{ item.TravelDay }}</b-row>
              <b-row style="font-weight: bold; margin-left: 0.2em; font-size: 1.35em">{{ FormatTime(item.PickupTime) }} Uhr</b-row>
              <b-row style="margin-left: 0.2em;">Fahrzeit: ca.&ensp;<strong>{{ parseInt(item.TripRoute.TripDuration / 60) }}</strong>&ensp;min</b-row>
              <b-row style="margin-left: 0.2em;">Entfernung: {{ parseInt(item.TripRoute.TripDistanceMeter / 1000) }}km</b-row>
              <b-row class="float-right mr-1">
                <div style="margin-top: -2.3em;" v-html="GetVoucherImage(item.RideType)"></div>
              </b-row>
            </b-col>
            <b-col cols="2">

              <b-row style="cursor: pointer">
                <b-dropdown
                    class="float-right"
                    size="sm"
                    v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                    variant="flat-dark"
                    right
                    :text="'V-ID: ' + item.Vid"
                >
                  <b-dropdown-item
                      variant="warning"
                      @click="OpenVoucher(item.Vid)"
                  >
                    Bearbeiten
                  </b-dropdown-item>
                  <b-dropdown-item
                      variant="success"
                      @click="VoucherLogs(item.Vid)"
                  >Logs
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
              <b-row>___________________</b-row>

              <b-row v-show="item.RideType == 1">Transportschein: {{ (item.MedicalTrip.TransportTicket ? 'Ja' : 'Nein') }}</b-row>
              <b-row v-show="item.RideType == 1">Termin: {{ (item.MedicalTrip.AppointmentTime) }} Uhr</b-row>
              <b-row v-show="item.RideType == 2">Wunsch Ank.: {{ (item.Flight.ScheduledTime) }} Uhr</b-row>
              <b-row v-show="item.RideType == 0">Flug: {{ item.Flight.Iata }} ({{ item.Flight.ScheduledTime }})</b-row>
              <b-row v-show="item.RideType == 0">{{ item.Flight.Departure }} ==> {{ item.Flight.Arrivals }}</b-row>
              <b-row>___________________</b-row>
              <b-row>Fahrgäste:
                <div style="fontWeight: bold; margin-left: 0.5em">{{ item.Passenger.Passengers }} - {{ item.Passenger.PassengersChildren }}</div>
              </b-row>
            </b-col>
            <b-col cols="3">
              <b-row>
                <b-col
                    md="12"
                    xl="12"
                    class="mb-1"
                >

                  <b-row>{{ item.PickUpAddress.Name }}</b-row>
                  <b-row>{{ item.PickUpAddress.Street }}</b-row>
                  <b-row>{{ item.PickUpAddress.ZipCode }} {{ item.PickUpAddress.Location }}
                    {{ item.PickUpAddress.District }}
                  </b-row>
                  <b-row>{{ item.PickUpAddress.Phone }}</b-row>
                  <b-row>{{ item.PickUpAddress.Phone2 }}</b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3" style="font-weight: bold;">
              <b-row>
                <b-col
                    md="12"
                    xl="12"
                    class="mb-1"
                >

                  <b-row>{{ item.DestinationAddress.Name }}</b-row>
                  <b-row>{{ item.DestinationAddress.Street }}</b-row>
                  <b-row>{{ item.DestinationAddress.ZipCode }} {{ item.DestinationAddress.Location }}
                    {{ item.DestinationAddress.District }}
                  </b-row>

                  <b-row>{{ item.DestinationAddress.Phone }}</b-row>
                  <b-row>{{ item.DestinationAddress.Phone2 }}</b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="2" style="margin: auto">
              <b-row>
                <b-button :disabled="item.Confirmed" :class="item.Confirmed ? 'btn-danger' : 'btn-success'" @click="ConfirmVoucher(item.Vid)">{{ item.Confirmed ? 'bereits bestätigt' : 'Bestätigen' }}</b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              {{ item.Description2 }}
            </b-col>
            <b-col cols="4">
              {{ item.Description1 }}
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">

              <b-badge
                  variant="warning"
                  v-show="item.Canceled"
                  class="mr-1"
              >
                Storniert
              </b-badge>
              <b-badge
                  v-show="item.Price.PaymentMethod == 1 && item.Price.PriceFull > 0"
                  variant="light-info"
              >
                Rechnung {{ FormatEuro(item.Price.PriceFull) }}
              </b-badge>
              <b-badge
                  v-show="item.Price.PaymentMethod == 2 && item.Price.PriceFull > 0"
                  variant="light-info"
              >
                Lastschrift {{ FormatEuro(item.Price.PriceFull) }}
              </b-badge>
              <b-badge
                  v-show="item.Price.PaymentMethod == 3 && item.Price.PriceFull > 0"
                  variant="light-info"
              >
                Barzahlung / EC {{ FormatEuro(item.Price.PriceFull) }}
              </b-badge>
            </b-col>
            <b-col cols="4">
            </b-col>
            <b-col cols="4">
              <b-badge class="float-right" variant="info" v-show="item.Customer.CustomerType == 1">Crew</b-badge>
              <b-badge class="float-right" variant="success" v-show="item.Customer.CustomerType == 2">Reisebüro</b-badge>
              <b-badge class="float-right" style="background-color: #480081; box-shadow: 0 0 9px rgba(78,24,178,0.5);">({{item.Customer.CustomerNumber}}) {{item.Customer.Name}}</b-badge>
              <connected-voucher-badge v-bind:vData="item.ConnectedVoucher"/>
            </b-col>
          </b-row>

        </div>

        <div
            v-for="item in items"
            style="padding: .95em; margin-bottom: 0.7em; border-radius: 0.3em; background-color: #252a3e;"
            v-show="isMobile"
        >
          <b-row class="p-1">
            <b-col cols="12">
              <b-row
                  v-show="item.Canceled"
                  class="float-right"
              >
                <b-badge
                    variant="warning"
                >
                  Storniert
                </b-badge>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-row style="font-weight: bold; font-size: 1.25em">{{ item.TravelWeekDay }}</b-row>
                  <b-row style="font-weight: bold; font-size: 1.75em">{{ item.TravelDay }}</b-row>
                </b-col>
                <b-col @click="OpenVoucher(item.Vid)" cols="5" class="float-left font-weight-bold">
                  <b-row>V-ID: {{ item.Vid }}</b-row>
                  <b-row>Fgst. {{ item.Passenger.Passengers }} - {{ item.Passenger.PassengersChildren }}</b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>KM: {{ parseInt(item.TripRoute.TripDuration / 60) }}</b-row>
                  <b-row>Min: {{ parseInt(item.TripRoute.TripDuration / 60) }}</b-row>
                </b-col>
                <b-col cols="4" class="float-right text-right font-weight-bold font-large-1">

                  {{ FormatTime(item.PickupTime) }}
                </b-col>

              </b-row>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col cols="12">
              <b-row><strong>Von:</strong>&ensp;{{ item.PickUpAddress.Name }}</b-row>
              <b-row>{{ item.PickUpAddress.Street }}</b-row>
              <b-row>{{ item.PickUpAddress.ZipCode }} {{ item.PickUpAddress.Location }}
                {{ item.PickUpAddress.District }}
              </b-row>
              <b-row class="font-weight-bold">Tel.:&emsp;<a :href="'tel:'+item.PickUpAddress.Phone">{{ item.PickUpAddress.Phone }}</a></b-row>
              <b-row v-show="item.PickUpAddress.Phone2 != ''"><a :href="'tel:'+item.PickUpAddress.Phone2">{{ item.PickUpAddress.Phone2 }}</a></b-row>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col cols="12">
              <b-row class="float-right text-right"><strong>Nach:</strong>&ensp;{{ item.DestinationAddress.Name }}</b-row><br>
              <b-row class="float-right text-right">{{ item.DestinationAddress.Street }}</b-row><br>
              <b-row class="float-right text-right">{{ item.DestinationAddress.ZipCode }} {{ item.DestinationAddress.Location }}
                {{ item.DestinationAddress.District }}
              </b-row><br>
              <b-row class="float-right text-right font-weight-bold">Tel.:&emsp;<a :href="'tel:'+item.DestinationAddress.Phone">{{ item.DestinationAddress.Phone }}</a></b-row><br>
              <b-row class="float-right text-right"  v-show="item.DestinationAddress.Phone2 != ''"><a :href="'tel:'+item.DestinationAddress.Phone2">{{ item.DestinationAddress.Phone2 }}</a></b-row><br>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col cols="12" style="font-size: 1.5em">
              <b-row v-show="item.RideType == 1">Transportschein: {{ (item.MedicalTrip.TransportTicket ? "Ja" : "Nein") }}</b-row>
              <b-row v-show="item.RideType == 1">Termin: {{ (item.MedicalTrip.AppointmentTime) }} Uhr</b-row>
              <b-row v-show="item.RideType == 0">Flug: {{ item.Flight.Iata }} ({{ item.Flight.ScheduledTime }})</b-row>
              <b-row v-show="item.RideType == 0">{{ item.Flight.Departure }} ==> {{ item.Flight.Arrivals }}</b-row>
            </b-col>

            <b-col cols="12" style="margin: auto">
              <b-row>
                <b-button :disabled="item.Confirmed" :class="item.Confirmed ? 'btn-danger btn-block' : 'btn-success btn-block'" @click="ConfirmVoucher(item.Vid)">{{ item.Confirmed ? 'bereits bestätigt' : 'Bestätigen' }}</b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              {{ item.Description2 }}
            </b-col>
            <b-col cols="4">
              {{ item.Description1 }}
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-badge
                  v-show="item.Price.PaymentMethod == 1 && item.Price.PriceFull > 0"
                  variant="light-info"
              >
                Rechnung {{ FormatEuro(item.Price.PriceFull) }}
              </b-badge>
              <b-badge
                  v-show="item.Price.PaymentMethod == 2 && item.Price.PriceFull > 0"
                  variant="light-info"
              >
                Lastschrift {{ FormatEuro(item.Price.PriceFull) }}
              </b-badge>
              <b-badge
                  v-show="item.Price.PaymentMethod == 3 && item.Price.PriceFull > 0"
                  variant="light-info"
              >
                Barzahlung / EC {{ FormatEuro(item.Price.PriceFull) }}
              </b-badge>
            </b-col>
            <b-col cols="4">
            </b-col>
            <b-col cols="4">
              <b-badge class="float-right" variant="info" v-show="item.Customer.CustomerType == 1">Crew</b-badge>
              <b-badge class="float-right" variant="success" v-show="item.Customer.CustomerType == 2">Reisebüro</b-badge>
              <b-badge class="float-right" style="background-color: #480081; box-shadow: 0 0 9px rgba(78,24,178,0.5);">({{item.Customer.CustomerNumber}}) {{item.Customer.Name}}</b-badge>
              <connected-voucher-badge v-bind:vData="item.ConnectedVoucher"/>
            </b-col>
          </b-row>

        </div>
      </b-col>


      <b-col
          cols="12"
          class="mb-2"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>

    <b-popover
        ref="popover"
        target="popover-vlogs"
        triggers="click"
        placement="auto"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Interactive Content</span>
        </div>
      </template>

      <div>

      </div>
    </b-popover>

    <b-modal
        no-close-on-backdrop
        hide-footer
        id="modal-booking-confirm"
        centered
        size="lg"
        title="Buchungsbestätigung"
    >
      <b-row v-for="m in mails">
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
                v-model="m.Checked"
            >
              {{ m.Name }} ({{ m.EMail }})
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button class="float-right" variant="success" @click="BookingConfirmation">
        <span v-show="!loading.bookingConform"> Senden </span>
        <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
        <div
            v-show="loading.bookingConform"
            class="spinner-border spinner-border-sm"
            role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </b-button>
    </b-modal>

  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormCheckbox, BDropdown,
  BDropdownDivider,
  BDropdownItem, VBTooltip, BPopover,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Ripple from 'vue-ripple-directive'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'

export default {
  components: {
    ConnectedVoucherBadge,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BPopover,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: {
        bookingConform: false
      },
      icon: {
        Fly: require('@/assets/images/dispo/flugzeug.png'),
        MedicalTrip: require('@/assets/images/dispo/krankenwagen.png'),
        Transfer: require('@/assets/images/dispo/taxi.png')
      },
      BookingConfirmationVid: 0,
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100, 150],
      totalRows: 1,
      currentPage: 1,
      filter: '',
      mails: [],
      filterTimeout: null,
      isMobile: false,
      fields: [
        {
          key: 'Voucher',
          label: 'Voucher',
        },
        {
          key: 'Flight',
          label: 'Flug',
        },
        {
          key: 'Price',
          label: 'Preis',
        },
        {
          key: 'PickUpAddress',
          label: 'Von Addresse',
        },
        {
          key: 'DestinationAddress',
          label: 'Nach Addresse',
        },
        {
          key: 'Info',
          label: 'Info',
        },
        {
          key: 'Action',
          label: 'Aktion',
        },
      ],
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key,
          }))
    },
  },
  sockets: {
    updateVoucher(voucher) {
      this.LoadList(voucher)
    },
    setConfirmVoucher(vid) {
      this.items.forEach((value, index) => {
        if (value.Vid == vid) {
          this.items[index].Confirmed = true
        }
      })
    },
  },
  mounted() {
    this.checkMobile();
    this.$nextTick(() => {
      document.title = 'Ktr. Eingabe'
    })
    this.LoadList(0)
    // Set the initial number of items
    this.totalRows = this.items.length
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList(0)
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList(0)
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList(0)
          }, 550)
        },
    )
  },
  methods: {

    checkMobile() {
      console.log(navigator.userAgent)
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    OpenVoucher(id) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: id }
      })
    },
    VoucherLogs(id) {
      this.$router.push({
        name: 'VoucherLogList',
        params: { vid: id }
      })
    },
    FormatTime(time) {
      return time.slice(0, 5)
    },

    GetVoucherImage(id) {
      if (id == 0) {
        return `<img src="${this.icon.Fly}" alt="Logo" width="32" style="filter: brightness(0) invert(1); transform: rotate(-75deg)" >`
      }

      if (id == 1) {
        return `<img src="${this.icon.MedicalTrip}" alt="Logo" width="32" style="filter: brightness(0) invert(1); transform: rotate(0deg)" >`
      }

      if (id == 2) {
        return `<img src="${this.icon.Transfer}" alt="Logo" width="32" style="filter: brightness(0) invert(1); transform: rotate(-75deg)" >`
      }

    },
    BookingConfirmation() {
      if (this.loading.bookingConform == true) {
        return
      }

      this.$http.post('/voucher/send/booking/confirmation/', JSON.stringify({
        Vid: this.BookingConfirmationVid,
        Mails: this.mails
      }))
          .then(resp2 => {
            if (resp2.data.success) {
              this.mails = []
              this.BookingConfirmationVid = 0
              this.$bvModal.hide('modal-booking-confirm')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ok',
                  icon: 'CheckIcon',
                  text: 'Buchungsbestätigung wird versendet.',
                  variant: 'info',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    ConfirmVoucher(vid) {
      this.$http.post('/voucher/confirm', parseInt(vid))
          .then(resp => {
            console.log(resp)
            if (resp.data.success) {
              if (resp.data.mails.length > 0) {
                this.mails = resp.data.mails
                this.BookingConfirmationVid = vid
                this.$bvModal.show('modal-booking-confirm')
              }
              // this.$swal({
              //   title: 'Buchungsbestätigung',
              //   text: 'Möchten sie eine Buchungsbestätigung senden?',
              //   icon: 'warning',
              //   showCancelButton: true,
              //   confirmButtonText: 'Ja, senden!',
              //   cancelButtonText: 'Nein, überspringen',
              //   customClass: {
              //     confirmButton: 'btn btn-primary',
              //     cancelButton: 'btn btn-outline-danger ml-1',
              //   },
              //   buttonsStyling: false,
              // })
              //     .then(result => {
              //       if (result.isConfirmed) {

              //       }
              //     })
            }
          })
          .catch(err => {
            console.error(err)
          })
      console.log(vid)
    },
    Click(record, index) {
      console.log(record)
      this.$router.push({
        name: 'VoucherMask',
        params: { id: record.Vid }
      })
    },
    LoadList(onlyUpdate) {
      if (onlyUpdate > 0) {
        this.$http.get('/voucher/unconfirmed?voucherId=' + onlyUpdate)
            .then(resp => {
              if (resp.data.success) {
                let isInList = false
                this.items.forEach((value, index) => {
                  if (value.Vid == resp.data.data.Vid) {
                    this.items.splice(index, 1)
                    this.items[index] = (resp.data.data)
                    isInList = true
                  }
                })
                if (!isInList) {
                  this.items.push(resp.data.data)
                }
              }
            })
            .catch(err => {
              console.error(err)
            })

      } else {
        this.items = []
        const c1 = (this.currentPage - 1) * this.perPage
        let url = `/voucher/unconfirmed/list?filter=${this.filter}&from=${c1}&count=${this.perPage}`
        if (this.filter && this.filter !== '') {
          url = `/voucher/unconfirmed/list?filter=${this.filter}`
        }
        this.$http.get(url)
            .then(resp => {
              this.totalRows = resp.data.info.fullEntries
              resp.data.list.forEach(i => {
                this.items.push(i)
              })
            })
            .catch(err => {
              console.error(err)
            })
      }

    },
  },
}
</script>
